import {
  REGISTER_COMPANY,
  REGISTER_COMPANY_ERROR,
  REGISTER_COMPANY_SUCCESS, REGISTER_PERSONALUSER, REGISTER_PERSONALUSER_ERROR, REGISTER_PERSONALUSER_SUCCESS
} from "./actionTypes"

const initialState = {
  message: null,
  companyloading: false,
  userloading:false,
  user: null,

  companyRegistrationSuccess: null,
  companyRegistrationError: null,
  userRegistrationSuccess: null,
  userRegistrationError: null,

}

const account = (state = initialState, action) => {
  switch (action.type) {

    case REGISTER_COMPANY:
      state = {
        ...state,
        companyloading: true,
      }
      break
    case REGISTER_COMPANY_SUCCESS:
      state = {
        ...state,
        companyloading: false,
        companyRegistrationSuccess: action.payload,
        companyRegistrationError : null,        
      }
      break
    case REGISTER_COMPANY_ERROR:
      state = {
        ...state,    
        companyloading: false,
        companyRegistrationError: action.payload,
      }
      break
    case REGISTER_PERSONALUSER:
        state = {
          ...state,
          userloading: true,
        }
        break
    case REGISTER_PERSONALUSER_SUCCESS:
        state = {
          ...state,
          userloading: false,
          userRegistrationSuccess: action.payload,
          userRegistrationError : null,          
        }
        break
    case REGISTER_PERSONALUSER_ERROR:
        state = {
          ...state,    
          userloading: false,
          userRegistrationError: action.payload,
        }
        break        
    default:
      state = { ...state }
      break
  }
  return state
}

export default account
